$(document).ready(function () {
    $('table.mandats-list > tbody').on('click', 'tr.ligne-clickable td', function(e) {
        var $td = $(e.currentTarget);
        var $tr = $td.parents('tr');
        if(!$td.hasClass('actions')) {
            window.location = $tr.data('url');
        }
    });
});
